import { render, staticRenderFns } from "./TreeSkeleton.vue?vue&type=template&id=b3884b88"
import script from "./TreeSkeleton.vue?vue&type=script&lang=js"
export * from "./TreeSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports